import { render } from "./detailDrawer.vue?vue&type=template&id=d3c19b88&scoped=true"
import script from "./detailDrawer.vue?vue&type=script&lang=js"
export * from "./detailDrawer.vue?vue&type=script&lang=js"

import "./detailDrawer.vue?vue&type=style&index=0&id=d3c19b88&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-d3c19b88"

export default script